<!--DatePickerDialog.vue -->
<template>
  <v-dialog v-model="displayDialog"
            width="300">
    <v-date-picker v-model="newDate"
                   :min="onlyfuture ? this.getToday(this.VuetifyDateFormat) : null"
                   :max="onlypast ? this.getToday(this.VuetifyDateFormat) : null"
                   color="primary">
      <div class="d-flex justify-space-between"
           style="width:100%;">
        <v-btn @click="cancel()"
               icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-btn v-if="clearable"
               @click="newDate ? clear() : null"
               icon>
          <v-icon :color="newDate ? 'error' : ''">mdi-delete</v-icon>
        </v-btn>
        <v-btn @click="newDate ? confirm() : null"
               icon>
          <v-icon :color="newDate ? '#09ad46' : ''">mdi-check</v-icon>
        </v-btn>
      </div>
    </v-date-picker>
  </v-dialog>
</template>


<script>
export default {
  name: "DatePickerDialog",
  props: ["inDate", "externalTrigger", "onlypast", "onlyfuture", "clearable"],

  data() {
    return {
      displayDialog: false,
      newDate: null,
    };
  },

  methods: {
    emitDate() {
      this.$emit("fetch", this.newDate);
    },

    cancel() {
      this.displayDialog = false;
    },

    clear() {
      this.newDate = null;
      this.emitDate();
      this.displayDialog = false;
    },

    confirm() {
      this.emitDate();
      this.displayDialog = false;
    },
  },

  watch: {
    displayDialog: function () {
      this.newDate = this.VuetifyFormatDate(this.inDate);
    },

    externalTrigger: function () {
      this.displayDialog = !this.displayDialog;
    },
  },

  computed: {},
};
</script>
